import React, { useState, useEffect, createContext, useContext } from "react";
import { useLocalstorageState } from "rooks";

export interface AuthContextInterface {
  isLogined: boolean;
  userId: string;
	firstName: string;
	lastName: string;
  email: string;
	sec_permissions: string[];
	currentPage: string;
  logout(): void;
  setProfile(params): void;
	setCurrentPage(params): void;
}

const initialState: AuthContextInterface = {
  isLogined: false,
  userId: "",
	firstName: "",
	lastName: "",
  email: "",
	sec_permissions: [],
	currentPage: "/",
  logout: () => {},
  setProfile: () => {},
  setCurrentPage: () => {},
};

export const AuthContext = createContext<AuthContextInterface>(
  initialState as AuthContextInterface
);

export const useAuthContext = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
	const [value, set] = useLocalstorageState("auth-state", initialState);
	const [state, setState] = useState(value);

	useEffect(() => {
    set(state);
    return () => {};
  }, [state, set]);

  const logout = () => {
		localStorage.setItem("bearerToken", "");
		localStorage.setItem("token", "");
    setState(initialState);
  };

  const setProfile = (data) => {
    setState({
      ...state,
			isLogined: true,
      userId: data?.userId,
      firstName: data?.firstName,
      lastName: data?.lastName,
			email: data?.email,
			sec_permissions: data?.sec_permissions,
    });
  };

	const setCurrentPage = (url) => {
		setState({
			...state,
			currentPage: url,
		})
	};

  return (
    <AuthContext.Provider
      value={{
        ...state,
        logout,
        setProfile,
				setCurrentPage,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
